import { render, staticRenderFns } from "./createBusinessUnitTemplate.vue?vue&type=template&id=07118070&scoped=true&"
import script from "./createBusinessUnitTemplate.vue?vue&type=script&lang=js&"
export * from "./createBusinessUnitTemplate.vue?vue&type=script&lang=js&"
import style0 from "./createBusinessUnitTemplate.vue?vue&type=style&index=0&id=07118070&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07118070",
  null
  
)

export default component.exports